/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// SMA-185 Q6. Added by hand, like several other models the offline SDK export
// drops (see groupDetailsDto.ts). The unarchive route exists on the API
// (groups.controller.ts POST :id/unarchive) but the offline generator cannot
// see it, so whoever next runs the generator against a running API will produce
// this same shape (unarchive-group.handler.ts UnarchiveGroupResponse).
export interface UnarchiveGroupResponse {
  unarchived: boolean;
}
